import React, { useState, useEffect } from "react";
import { Accordion, Card } from "react-bootstrap";
import DynamicTable from "../Components/DynamicTable.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Moment from "moment";
import PuffLoader from "react-spinners/PuffLoader";

const UserRequestsAccordion = (props) => {
  const [accordionExpanded, setAccordionExpanded] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [mouseDownOnSearchBar, setMouseDownOnSearchBar] = useState(false);

  useEffect(() => {
    const resetMouseDownOnSearchBar = () => {
      setMouseDownOnSearchBar(false);
    };
    window.addEventListener("mouseup", resetMouseDownOnSearchBar);
    return () => window.removeEventListener("mouseup", resetMouseDownOnSearchBar);
  }, []);

  const handleAccordionHeaderMouseUp = () => {
    if (!mouseDownOnSearchBar) {
      setAccordionExpanded((prevExpanded) => !prevExpanded);
    }
  };

  const handleSearchBarMouseUp = () => {
    if (mouseDownOnSearchBar && !accordionExpanded) {
      setAccordionExpanded((prevExpanded) => !prevExpanded);
    }
  };

  const handleAccordionSpaceBarPress = (e) => {
    if (e.code === "Space" || e.key === " ") {
      e.preventDefault();
      setSearchQuery((prev) => prev + " ");
    }
  };

  const formatStatusString = (status) => {
    if (status === "OPEN") {
      return "Not Started";
    }
    if (status === "INPROGRESS") {
      return "In Progress";
    }
    return "";
  };

  const filterRows = (request, query) => {
    const job = props.type.toLowerCase().includes("remove") ? request.UserPosition : request.JobTitle;
    if (props.type.toLowerCase().includes("incomplete")) {
      return (
        request.UserFullName.toLowerCase().includes(query.toLowerCase()) ||
        job.toLowerCase().includes(query.toLowerCase()) ||
        Moment(request.CreatedDate).format("MMMM Do YYYY, h:mma").toLowerCase().includes(query.toLowerCase()) ||
        formatStatusString(request.Status).toLowerCase().includes(query.toLowerCase())
      );
    } else if (props.type.toLowerCase().includes("completed")) {
      return (
        request.UserFullName.toLowerCase().includes(query.toLowerCase()) ||
        job.toLowerCase().includes(query.toLowerCase()) ||
        Moment(request.CreatedDate).format("MMMM Do YYYY, h:mma").toLowerCase().includes(query.toLowerCase()) ||
        request.CompletedBy.toLowerCase().includes(query.toLowerCase()) ||
        Moment(request.CompletedDate).format("MMMM Do YYYY, h:mma").toLowerCase().includes(query.toLowerCase())
      );
    }
  };

  const onRequestDetailsClick = (request) => {
    props.setCurrentRequest(request);
    props.setShowModal(true);
  };

  const getAccordionName = () => {
    if (props.type.toLowerCase().includes("remove")) {
      return "Remove User Requests";
    } else if (props.type.toLowerCase().includes("change")) {
      return "Change User Requests";
    } else if (props.type.toLowerCase().includes("add")) {
      return "Add User Requests";
    }
  };

  const tableHeader = (
    <>
      <td className="col-sm">
        <strong>Employee Name</strong>
      </td>
      <td className="col-sm">
        <strong>Job Title</strong>
      </td>
      {props.isMobile === false && (
        <td className="col-sm">
          <strong>Date Requested</strong>
        </td>
      )}
      {props.isMobile === false && props.type.toLowerCase().includes("incomplete") && (
        <td className="col-sm">
          <strong>Status</strong>
        </td>
      )}
      {props.type.toLowerCase().includes("completed") && !props.isMobile && (
        <>
          <td className="col-sm">
            <strong>Completed By</strong>
          </td>
          <td className="col-sm">
            <strong>Completion Date</strong>
          </td>
        </>
      )}
      <td className="col-sm-1"></td>
    </>
  );

  const tableRows = (query) => {
    return (
      props.userActions &&
      [...props.userActions]
        .filter((request) => filterRows(request, query))
        .sort((a, b) => new Date(b.CreatedDate) - new Date(a.CreatedDate))
        .map((request) => {
          return (
            <>
              <td className="col-sm">{request.UserFullName}</td>
              <td className="col-sm">
                {props.type.toLowerCase().includes("remove") ? request.UserPosition : request.JobTitle}
              </td>
              {!props.isMobile && (
                <td className="col-sm">{Moment(request.CreatedDate).format("MMMM Do YYYY, h:mma")}</td>
              )}
              {!props.isMobile && props.type.toLowerCase().includes("completed") && (
                <td className="col-sm">{request.CompletedBy}</td>
              )}
              {!props.isMobile && props.type.toLowerCase().includes("completed") && (
                <td className="col-sm">{Moment(request.CompletedDate).format("MMMM Do YYYY, h:mma")}</td>
              )}
              {!props.isMobile && props.type.toLowerCase().includes("incomplete") && (
                <td className="col-sm">
                  {formatStatusString(request.Status)}
                  {formatStatusString(request.Status) === "In Progress"
                    ? " - " + request.LastUpdatedBy.slice(1, -1)
                    : ""}
                </td>
              )}
              <td className="col-sm-1">
                {props.requestBeingUpdated === request.RequestId ? (
                  <div style={{ marginRight: "42px", marginBottom: "42px" }}>
                    <PuffLoader size={40} color="black" loading={true} />
                  </div>
                ) : (
                  <button
                    className="btn float-right"
                    onClick={() => onRequestDetailsClick(request)}
                    style={{ backgroundColor: "rgb(134 163 225)" }}
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                )}
              </td>
            </>
          );
        })
    );
  };

  return (
    <Accordion activeKey={accordionExpanded}>
      <Card className="m-2">
        <Accordion.Item id="accordionButton" eventKey={true} className="base-accordion">
          <Accordion.Header
            as={Card.Header}
            onMouseUp={handleAccordionHeaderMouseUp}
            onKeyDown={(e) => handleAccordionSpaceBarPress(e)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <h5>
                {getAccordionName()} - {props.userActions.length}
              </h5>
              <input
                type="text"
                placeholder="Search"
                value={searchQuery}
                className="me-4"
                onChange={(e) => setSearchQuery(e.target.value)}
                onMouseDown={() => setMouseDownOnSearchBar(true)}
                onMouseUp={handleSearchBarMouseUp}
              />
            </div>
          </Accordion.Header>
          <Accordion.Body>
            <DynamicTable header={tableHeader} rows={tableRows(searchQuery)} />
          </Accordion.Body>
        </Accordion.Item>
      </Card>
    </Accordion>
  );
};

export default UserRequestsAccordion;
